import type { Runtime } from "../../components/common/runtime";
import type { AuditEvent, BlockRecord } from "../../types";

// Production history across every block: the closest thing the prototype has
// to an overview screen.
export default function Dashboard({ runtime }: { runtime: Runtime }) {
  const { t } = runtime.i18n;
  const state = runtime.state.getState();
  const records = Object.values(state.demo.blocks) as BlockRecord[];
  const events: AuditEvent[] = [...state.demo.globalAudit, ...records.flatMap(record => record.auditLog)]
    .sort((a, b) => Date.parse(b.timestamp) - Date.parse(a.timestamp));

  return <main id="view" className="page">
    <div className="page-head"><div><h1>{t("timeline.title")}</h1><p className="lead">{t("timeline.lead")}</p></div></div>
    <div className="timeline">{events.map(event => <article className="timeline-item" key={event.id}>
      <div className="muted">{runtime.ui.formatDate(event.timestamp)} · {event.actor}</div>
      <strong>{event.action}</strong><p>{event.detail}</p>
    </article>)}{!events.length && <p>{t("timeline.empty")}</p>}</div>
  </main>;
}
